import { SettingsService } from 'src/app/pages/settings/settings.service';
import { AuthService } from 'src/app/services';
import { Router } from '@angular/router';
import { TaskService, TaskGroupIdsEnum } from './../task.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Task } from '../task.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { TaskData } from '../../stock/stock.service';
import { Project, ProjectService } from '../../general/project.service';
import { DxDropDownBoxComponent, DxSliderComponent, DxTextBoxComponent, DxValidationSummaryComponent } from 'devextreme-angular';

import { Observable } from 'rxjs/internal/Observable';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-task-popup',
    templateUrl: './task-popup.component.html',
    styleUrls: ['./task-popup.component.scss'],
    standalone: false
})
export class TaskPopupComponent implements OnInit {
  public reload: boolean = true;

  private _reload() {
    setTimeout(() => this.reload = false);
    setTimeout(() => this.reload = true);
  }

  @ViewChild("dxChildTasks", { static: false }) dxddlchildTasks: DxDropDownBoxComponent;

  @Input() show: boolean;
  @Input() isEditPopup: boolean;
  @Input() isMinified: boolean;

  @Input() currentUrl = '';
  @Input() taskDescription: string;

  @Input() selectedRows: string[] = [];
  @Input() startDate: Date | number | string;
  @Input() deadlineDate: Date | number | string;
  @Input() priority: string;
  @Input() allowReminder: boolean;
  @Input() link: string;
  @Input() solutionDescription: string;
  @Input() status: string;
  @Input() progress: number;

  progressNew: number = 0;
  @Input() get progressChangedValue(): number { return this.progressNew; }
  set progressChangedValue(progressChangedValue: number) {
    this.progressNew = progressChangedValue;
    this.progress = progressChangedValue;
    if (this.dxslider != undefined && this.dxslider.instance != undefined
      && this.dxslider != null && this.dxslider.instance != null) {
      this.dxslider.instance.repaint();
    }

  }

  user: string[] = [];

  @Input() get responsibleUser(): string { return (this.user != null && this.user.length > 0 ? this.user[0] : null); }
  set responsibleUser(responsibleUser: string) {
    let $this = this;
    if (responsibleUser != null && responsibleUser != "") {
      $this.user = [];
      $this.user.push(responsibleUser);
      $this.ref.detectChanges();
    }

  }

  taskGrp1: string[] = []
  @Input() get taskGroup1(): string { return (this.taskGrp1 != null && this.taskGrp1.length > 0 ? this.taskGrp1[0] : null); }
  set taskGroup1(taskGroup1: string) {
    let $this = this;
    if (taskGroup1 != null && taskGroup1 != "") {
      $this.taskGrp1 = [];
      $this.taskGrp1.push(taskGroup1);
      $this.ref.detectChanges();
    }

  }

  taskGrp2: string[] = []
  @Input() get taskGroup2(): string { return (this.taskGrp2 != null && this.taskGrp2.length > 0 ? this.taskGrp2[0] : null); }
  set taskGroup2(taskGroup2: string) {
    let $this = this;
    if (taskGroup2 != null && taskGroup2 != "") {
      $this.taskGrp2 = [];
      $this.taskGrp2.push(taskGroup2);
      $this.ref.detectChanges();
    }

  }

  pid: number[] = []
  @Input() get projectId(): number { return (this.pid != null && this.pid.length > 0 ? this.pid[0] : null); }
  set projectId(projectId: number) {
    let $this = this;
    if (projectId != null) {
      $this.pid = [];
      $this.pid.push(projectId);
    }

  }

  ptaskId: number[] = []
  @Input() get parentTaskId(): number { return (this.ptaskId != null && this.ptaskId.length > 0 ? this.ptaskId[0] : null); }
  set parentTaskId(parentTaskId: number) {
    let $this = this;
    if (parentTaskId != null) {
      $this.ptaskId = [];
      $this.ptaskId.push(parentTaskId);

    }

  }


  mdltaskName: string;
  @Input() get taskName(): string { return (this.mdltaskName != null ? this.mdltaskName : null); }
  set taskName(taskName: string) {
    let $this = this;
    if (taskName != null && taskName != "") {
      $this.mdltaskName = taskName;
      $this.ref.detectChanges();
    }
  }

  @Input() taskId: number;

  @Input() newIdToReplaceAutogeneratedGUID: number;


  tasks: Task[] = undefined;
  public parentTasks: Task[] = [];

  @Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() onSubmitted: EventEmitter<Task> = new EventEmitter<Task>();

  task: Task = new Task();
  now = new Date();
  deadlineDefault: Date = new Date();
  title = 'Create new Task';
  taskPriorities: string[] = [];

  taskStatuses: string[] = [];

  taskGroupValues1 = []

  taskGroupValues2 = []

  infPopupTitleTask = '';
  infoPopupTaskMessage = '';
  showInfoPopupTask = false;
  public projects: Project[];
  userNames = []

  isGridBoxOpened: boolean;

  constructor(
    private taskService: TaskService,
    private router: Router,
    private authService: AuthService,
    private shareDataService: ShareDataService,
    private projectService: ProjectService,
    private ref: ChangeDetectorRef,
    private _settingsService: SettingsService,
  ) { }

  ngOnInit() {
    if (this.isEditPopup) {
      this.title = 'Edit Task';
      this.loaddefaultData();
    }
    else {

        this.loaddefaultData();

    }

    if (!this.startDate) {
      this.startDate = this.now;
    }

    if (this.user != undefined && this.user != null && this.user.length == 0) {
      this.user.push(this.authService.currentUserName);
    }

    if (this.cleanTaskEvents) {
      this.cleanTaskEvents.subscribe(() => this.cleanTask());
    }
  }

  public setDefaultValuesIfNone() {
    if (!this.priority && this.taskPriorities.length > 0) {
      this.priority = this.taskPriorities[0];
    }

    if (!this.status && this.taskStatuses.length > 0) {
      this.status = this.taskStatuses[0];
    }

    if (!this.startDate) {
      this.startDate = this.now;
    }

    if (!this.deadlineDate) {
      this.deadlineDate = this.deadlineDefault;
    }


    if (this.user != undefined && this.user != null && this.user.length == 0) {
      this.user = [];
      this.user.push(this.authService.currentUserName)
    }

  }

  public updateParentTasks() {
    if (this.pid != null && this.tasks != null && this.pid.length > 0) {
      this.parentTasks = this.tasks.filter((task) => task.projectId === this.pid[0] && !task.isActive);

    } else if (this.tasks) {
      this.parentTasks = [...this.tasks].filter((task) => !task.isActive);

    }

    if (this.dxddlchildTasks && this.dxddlchildTasks.instance) {
      this.dxddlchildTasks.instance.repaint();
    }
  }

  public updateCollections() {
    const $this = this;

    this.projectService.getProjects({showLoadingIndicator:false}).subscribe(
      (response) => {
        $this.projects = response.filter(
          (project) => project.isActive
        ).sort(
          (a, b) => a.createdOn > b.createdOn ? -1 : 1
        );
      }
    );
    this.updateParentTasks();
  }

  public onShown(event: any) {

    this.loaddefaultData();
    this.setDefaultValuesIfNone();

    this.updateParentTasks();
  }

  IsloaddefaultDataLoaded = false;
  loaddefaultData() {

    const $this = this;

    if (!this.tasks) {
      this.projectService.getTasks(
        {
          name: 'ngOnInit -> getTasks',
          showLoadingIndicator:false,
          responseLoggingEnabled: false
        }
      ).subscribe(
        {
          next: (response: Task[]) => {
            $this.tasks = response;
          }
        }
      );
    }

    this._settingsService.getCoreSetting(null, "TaskDefaultDeadlineDays", false,{showLoadingIndicator:false}).then(
      (response) => {
        this.deadlineDefault.setDate(this.deadlineDefault.getDate() + +response.value);
      }
    );

    if (this.pid == null) {
      this.pid = [];
    }
    if (this.pid != undefined && this.pid != null && this.pid.length == 0) {
      this._settingsService.getCoreSetting(null, "MainProjectId", false,{showLoadingIndicator:false}).then(
        (response) => {
          this.pid.push(+response.value);

          this.updateCollections();
        });
    }
    else {
      this.updateCollections();
    }

    if (!this.IsloaddefaultDataLoaded) {
      this.taskService.getTaskPriorities({showLoadingIndicator:false}).subscribe(result => {
        result.forEach(element => {
          this.taskPriorities.push(element.listElement);

          if (!this.priority && element.isDefault) {
            this.priority = element.listElement;
          }
        });
      });

      this.taskService.getTaskStatuses({showLoadingIndicator:false}).subscribe(result => {
        result.forEach(element => {
          this.taskStatuses.push(element.listElement);

          if (!this.status && element.isDefault) {
            this.status = element.listElement;
          }
        });
      });
      this.taskService.getTaskGroups({showLoadingIndicator:false}).subscribe(result => {
        result.forEach(element => {
          if (element.listId === TaskGroupIdsEnum.TaskGroup1) {
            let obj = {};
            obj['TaskGroup1'] = element.listElement
            this.taskGroupValues1.push(obj);

          }

          if (element.listId === TaskGroupIdsEnum.TaskGroup2) {
            let obj = {};
            obj['TaskGroup2'] = element.listElement
            this.taskGroupValues2.push(obj);
          }

        });

      });
      this.taskService.getUserList({showLoadingIndicator:false}).subscribe(result => {
        for (let uname of result) {
          let obj = {};
          obj['Username'] = uname
          this.userNames.push(obj);
        }

      });
      this.IsloaddefaultDataLoaded = true;
    }
  }

  cancelTask() {
    this.show = false;
  }

  changePopupStatus() {
    this.cleanTask();
    this.showChange.emit(this.show);
  }

  goToLink() {

    if (this.link.indexOf('?') > -1) {
      this.link += '&taskid=' + this.taskId;
    }
    else {
      this.link += '?taskid=' + this.taskId;
    }

    this.router.navigateByUrl(this.link).then(() => {
    });
  }

  taskFilter: TaskData[] = [];
  taskNewFilter: TaskData;

  onTaskFormSubmit(e) {

    this.taskFilter = [];

    if (this.shareDataService.filterOptions && this.shareDataService.filterOptions.filters) {
      this.shareDataService.filterOptions.filters.forEach(itemFilter => {
        this.taskNewFilter = new TaskData();
        this.taskNewFilter.SettingValue = itemFilter.fieldValue;
        this.taskNewFilter.SettingId = itemFilter.settingId;
        this.taskNewFilter.FieldName = '';
        this.taskFilter.push(this.taskNewFilter);
      });
    }

    if (this.shareDataService.filterOptionOverview && this.shareDataService.filterOptionOverview.filters) {
      this.shareDataService.filterOptionOverview.filters.forEach(itemFilter => {
        this.taskNewFilter = new TaskData();
        this.taskNewFilter.SettingValue = itemFilter.value;
        this.taskNewFilter.FieldName = itemFilter.fieldName;
        this.taskNewFilter.SettingId = null;
        this.taskFilter.push(this.taskNewFilter);
      });
    }

    if (this.taskId != null && this.taskId != undefined) {
      this.task.taskId = this.taskId;
    }


    if (this.ptaskId != undefined && this.ptaskId != null && this.ptaskId.length > 0) {
      this.task.parentTaskId = this.ptaskId[0];
    }

    this.task.taskName = this.mdltaskName;
    this.dxtxtTaskName.instance.repaint();

    this.task.taskDescription = this.taskDescription;

    this.task.responsibleUser = this.responsibleUser;
    this.task.startDate = this.startDate;
    this.task.deadlineDate = this.deadlineDate;
    this.task.priority = this.priority;
    this.task.allowReminder = this.allowReminder;
    this.task.solutionDescription = this.solutionDescription;
    this.task.status = this.status;
    this.task.link = this.isEditPopup ? this.link : this.currentUrl;

    this.task.taskGroup1 = this.taskGroup1;
    this.task.taskGroup2 = this.taskGroup2;

    this.task.progress = this.progress;

    if (this.projectId != null && this.projectId != undefined) {
    this.task.projectId = this.projectId;
    }

    this.task.taskFilterData = this.taskFilter;
    this.task.newIdToReplaceAutogeneratedGUID = this.newIdToReplaceAutogeneratedGUID;

    this.onSubmitted.emit(this.task);

    if (!this.isEditPopup) {
      this.taskService.createNewTask(this.task).subscribe(result => {
        this.task = new Task();
        this.showInfoPopupTask = true;
        this.infPopupTitleTask = 'Added';
        this.infoPopupTaskMessage = 'Task added successfully';
        this.show = false;
      });
    } else {
      this.task.taskId = this.taskId;

      this.task.prepareForUpdate(this.tasks);

      this.taskService.updateTask(this.task).subscribe(result => {
        this.task = new Task();
        this.showInfoPopupTask = true;
        this.infPopupTitleTask = 'Updated';
        this.infoPopupTaskMessage = 'Task updated successfully';
        this.show = false;
      });
    }
  }

  changeInfoPopupStatusTask() {
    this.showInfoPopupTask = false;
    this.infPopupTitleTask = '';
    this.infoPopupTaskMessage = '';
  }

  public progressFormat(value: any) {
    return value + "%";
  }

  public onProjectIdValueChanged(event: any) {
    console.log("onProjectIdValueChanged - event:", event);

    if (!event.value) {
      this.pid = [];

    }
    this.updateParentTasks();
  }

  public onStatusValueChanged(event: any) {
    console.log("onStatusValueChanged - event:", event);

    if (event.value) {
      if (event.value.trim().toLowerCase() === "done") {
        this.progress = 100;
      } else if (event.value.trim().toLowerCase() === "in progress" && event.previousValue.trim().toLowerCase() === "done") {
        this.progress = 50;
      } else if (event.value.trim().toLowerCase() === "in progress" && event.previousValue.trim().toLowerCase() === "pending") {
        this.progress = 50;
      } else if (event.value.trim().toLowerCase() === "pending") {
        this.progress = 0;
      }
    }
    this.dxslider.instance.repaint();
  }


  @Input() cleanTaskEvents: Observable<void>;
  @ViewChild('formDirective') myForm: NgForm;
  @ViewChild("txtTaskName", { static: false }) dxtxtTaskName: DxTextBoxComponent;
  @ViewChild("ddltaskGroup1", { static: false }) dxddltaskGroup1: DxDropDownBoxComponent;
  @ViewChild("ddltaskGroup2", { static: false }) dxddltaskGroup2: DxDropDownBoxComponent;
  @ViewChild("ddlProject", { static: false }) dxddlProject: DxDropDownBoxComponent;
  @ViewChild("summary", { static: false }) dxsummary: DxValidationSummaryComponent;
  @ViewChild("slider", { static: false }) dxslider: DxSliderComponent;


  cleanTask() {
    this.taskId = null;

    this.taskDescription = "";
    this.user = [];
    this.deadlineDate = null;
    this.allowReminder = false;
    this.link = "";
    this.solutionDescription = "";
    this.progress = 0;
    this.dxtxtTaskName.instance.reset();
    this.dxddltaskGroup1.instance.reset();
    this.dxddltaskGroup2.instance.reset();
    this.dxddlProject.instance.reset();
    this.dxslider.instance.repaint();
    if (this.dxddlchildTasks && this.dxddlchildTasks.instance) {
      this.dxddlchildTasks.instance.reset();
    }
    this.myForm.resetForm();
  }
}
